import { observer } from 'mobx-react-lite';
import type { EditBlockStore } from '../../store';

import { EditDropdownType } from '../../types';
import { getDropdownType } from '../../utils';
import { EditActionValueDropdownList } from './EditActionValueDropdownList';
import { EditActionValueDropdownString } from './EditActionValueDropdownString';

interface EditActionValueDropdownProps {
	store: EditBlockStore;
	actionSearchKey: string;
	onItemClick: (
		value: string | boolean,
		shouldClose: boolean,
		label?: string
	) => void;
}

export const EditActionValueDropdown = observer(
	({ store, actionSearchKey, onItemClick }: EditActionValueDropdownProps) => {
		const editAction = store.editActions.get(actionSearchKey)!;
		const dropdownType = getDropdownType(editAction.editAction.type);
		switch (dropdownType) {
			case EditDropdownType.LIST: {
				return (
					<EditActionValueDropdownList
						store={store}
						actionSearchKey={actionSearchKey}
						onItemClick={onItemClick}
					/>
				);
			}
			case EditDropdownType.STRING: {
				return (
					<EditActionValueDropdownString
						store={store}
						actionSearchKey={actionSearchKey}
						onItemClick={onItemClick}
					/>
				);
			}
			default: {
				// eslint-disable-next-line no-console
				console.error('Invalid dropdown type');
				return null;
			}
		}
	}
);
